import {ApiUrls} from 'shared/config/model/urls';

import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {AxiosRequestHeaders} from 'axios';
import {t} from '@lingui/core/macro';

import createHttpRequest from 'shared/api/http';

import {UNSUBSCRIBE_MODE_ALL, UNSUBSCRIBE_MODE_MONITOR} from '../lib/accountLinks';

interface IUnsubscribeInfo {
    monitor_url: string,
    email: string,
}

export const useNotificationsUnsubscribe = () => {
    const {id} = useParams<{id: string}>();
    const [isUnsubscribed, setIsUnsubscribed] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [info, setInfo] = useState<IUnsubscribeInfo>({monitor_url: '', email: ''});

    useEffect(() => {
        if (!id) return;

        createHttpRequest({
            method: 'GET',
            path: ApiUrls.UNSUBSCRIBE_FROM_EMAIL_NOTIFICATIONS_INFO(id),
            isAnonymous: true,
        }).then((response) => {
            setIsLoading(false);
            setInfo(response.data);
        }, () => {
            setIsError(true);
        }).catch(() => {
            setIsError(true);
        });
    }, [id]);

    const unsubscribe = (mode: number) => {
        if (!id || !confirm(t`Подтверждайте действие?`)) return;

        setIsLoading(true);
        createHttpRequest({
            method: 'POST',
            data: {},
            headers: {
                'Content-type': 'application/json',
            } as unknown as AxiosRequestHeaders,
            path: ApiUrls.HTTP_MONITOR_UNSUBSCRIBE_FROM_EMAIL_NOTIFICATIONS_ACTION(id, mode),
            isAnonymous: true,
        }).then(() => {
            setIsUnsubscribed(true);
            setIsLoading(false);
        });
    };

    return {
        isNotFound: !id || isError,
        isLoading,
        isUnsubscribed,
        email: info.email,
        monitorUrl: info.monitor_url,
        unsubscribeMonitor: () => unsubscribe(UNSUBSCRIBE_MODE_MONITOR),
        unsubscribeAll: () => unsubscribe(UNSUBSCRIBE_MODE_ALL),
    };
};

export default useNotificationsUnsubscribe;
